<template>
  <div>
    <header class="digibook-header" id="header">
      <div class="container holder">
        <router-link
          :to="{name: 'a005'}"
          v-if="['a005','a095', '999'].indexOf($route.name)   !== -1"
          class="logo"
        >
          <img src="../../assets/images/logo.png" alt="logo" />
        </router-link>
        <font-awesome-icon icon="arrow-left"  v-else 
          class="icon-back"  
          alt="ico_back"
          @click="backScreenHandle"
          :class="{ hiden: $route.meta.hideBack, inactive: routeInactive }"
        />
        <!-- <img
          v-else
          class="icon-back"
          src="../../assets/icons/ico_back.svg"
          alt="ico_back"
          @click="backScreenHandle"
          :class="{ hiden: $route.meta.hideBack, inactive: routeInactive }"
        /> -->

        <div class="left position-relative w-100">
          <div class="name">
            <div v-if="['a005','a095', '999'].indexOf($route.name)   !== -1">
              <span>{{$t('front_end.common.page_name_first')}}</span>
              <span @click="onChangeShopMode">{{$t('front_end.common.page_name_last')}}</span>
            </div>
            <div v-else>{{ pageName }}</div>
          </div>
        </div>

        <div class="header-name">
          <div
            class="shop_name"
            v-if="shopNameLabel"
          >{{ $t("front_end.shop_mode.label")}}{{ shopNameLabel }}</div>
        </div>
      </div>
    </header>

    <fe-alert ref="releaseComponent" :datas="dataAlert">
      <template v-slot:default>
        <div class="form-group text-center cursor-default">
          <p v-html="releaseAlert.content"></p>
        </div>
      </template>
      <template v-slot:action>
        <button
          type="button"
          @click="onClickOkRelease"
          class="btn-dialog col-6 border-top border-right"
        >{{ releaseAlert.label_release}}</button>
        <button
          type="button"
          @click="onClickCancelRelease"
          class="btn-dialog col-6 border-top border-left"
        >{{ releaseAlert.label_cancel }}</button>
      </template>
    </fe-alert>

    <ValidationObserver ref="form" v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(doEnterShopMode)" method="POST" action>
        <fe-alert ref="enterComponent" :datas="dataAlert" @modal-close="resetForm()">
          <template v-slot:default>
            <div class="form-group text-center cursor-default">
              <p v-html="enterAlert.content"></p>
              <ValidationProvider
                mode="passive"
                vid="loginid"
                :name="enterAlert.shop_id_label"
                rules="required|max:3|half_size|numeric"
                v-slot="{ errors, classes, failedRules }"
              >
                <input
                  type="text"
                  :class="classes"
                  id="insert-code"
                  autofocus="autofocus"
                  v-model="shopMode.shopId"
                  autocomplete="off"
                  vid="shopId"
                  @keyup.enter="doEnterShopMode"
                  class="input-shop-code form-control"
                />

                <span
                  v-if="failedRules.half_size"
                  class="text-danger"
                >{{ $t('front_end.a100.errors.type_halfsize')}}</span>
                <span class="text-danger" v-else>{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </template>
          <template v-slot:action>
            <button
              type="submit"
              class="btn-dialog col-6 border-top border-right"
            >{{ enterAlert.label_enter }}</button>
            <button
              type="button"
              @click="onClickCancelEnter"
              class="btn-dialog col-6 border-top border-left"
            >{{ enterAlert.label_cancel }}</button>
          </template>
        </fe-alert>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import FeAlert from "@/components/fe/common/FeAlert";
import { mapGetters } from "vuex";
import _ from "lodash";

export default {
  name: "headerComponent",
  components: {
    FeAlert
  },
  data() {
    return {
      title: "",
      isShowDialog: false,
      shopNameLabel: "",
      dataAlert: {
        isShow: false,
        isShowClose: true,
        opts: {
          keyboard: false,
          backdrop: "static"
        }
      }
    };
  },
  watch: {
    "shopMode.shopName": {
      handler: function() {
        // console.log("shopName", newValue);
      }
    },
    $route: {
      immediate: true,
      handler() {
        if (this.$refs?.releaseComponent) {
          this.$refs.releaseComponent.hide();
        }
        if (this.$refs?.enterComponent) {
          this.$refs.enterComponent.hide();
        }
      }
    }
  },
  created() {
    this.shopNameLabel = this.shopMode.shopName;
  },
  computed: {
    ...mapGetters(["shopMode", "userData"]),

    pageName() {
      let title =
        this.$route.meta && this.$route.meta.title
          ? this.$t(this.$route.meta.title)
          : "";

      return this.title ? this.title : title ? title : "";
    },
    releaseAlert() {
      return {
        content: this.$t("front_end.shop_mode.alert_release.content").join(
          "<br >"
        ),
        label_release: this.$t("front_end.shop_mode.alert_release.btn.release"),
        label_cancel: this.$t("front_end.shop_mode.alert_release.btn.cancel")
      };
    },
    enterAlert() {
      return {
        content: this.$t("front_end.shop_mode.alert_enter.content").join(
          "<br >"
        ),
        label_enter: this.$t("front_end.shop_mode.alert_enter.btn.enter"),
        label_cancel: this.$t("front_end.shop_mode.alert_enter.btn.cancel"),
        shop_id_label: this.$t("front_end.shop_mode.alert_enter.shop_id_label")
      };
    },
    routeInactive() {
      return this.$route.meta.back === "inactive";
    }
  },
  methods: {
    getShopMode() {
      // console.log("this.shopMode", this.shopMode);
    },
    onClickOkRelease() {
      this.setEmptyShopData();
      this.$refs.releaseComponent.hide();
    },
    setEmptyShopData() {
      this.$store.dispatch("shopMode/doReleaseShopMode", {});
      delete this.shopMode.shopId;
      delete this.shopMode.shopName;
      this.shopNameLabel = "";
    },
    doEnterShopMode() {
      let body = { shopId: this.shopMode.shopId };

      this.$store
        .dispatch("shopMode/doEnderShopMode", body)
        .then(e => {
          if (this.$route.name !== "a005") {
            this.$router.push({ name: "a005" });
          } else {
            this.$refs.enterComponent.hide();
          }
          this.shopNameLabel = e.shopName;
        })
        .catch(() => {
          this.$refs.form.setErrors({
            loginid: this.$t("front_end.shop_mode.messages.store_not_exist")
          });
        });
    },
    onChangeShopMode() {
      if (!_.isEmpty(this.shopMode.shopName)) {
        this.$refs.releaseComponent.show();
      } else {
        this.$refs.enterComponent.show();
      }
    },

    onClickCancelRelease() {
      this.$refs.releaseComponent.hide();
    },
    onClickCancelEnter() {
      this.$refs.enterComponent.hide();
    },

    backScreenHandle() {
      //update a025 inactive back btn
      if (this.$route.meta && this.$route.meta.back) {
        if (this.$route.meta.back == "inactive") {
          return "";
        } else if (this.$route.meta.back == "a008_category") {
          let definision = this.userData.selected.definision;
          let d = this.$t("front_end.a008.mapUrl")[definision];
          this.$router.push({
            name: "a008_category",
            params: { definision: d }
          });
        } else {
          let name = 
            this.$route.meta && this.$route.meta.back
              ? this.$route.meta.back
              : "a005";

          this.$router.push({ name });
        }
      } else {
        this.$root.$emit("header-back");
      }
    },
    resetForm() {
      if (!_.isEmpty(this.shopMode.shopName)) {
        return;
      }
      this.$refs.form.reset();
      this.setEmptyShopData();
    }
  }
};
</script>

<style scoped src="../../assets/css/common/header.css"></style>
<style scoped>
.hiden {
  display: none;
}
.header-name {
  position: absolute;
  right: 0;
}

@media screen and (max-width: 800px) {
  .header-name {
    top: 5px;
  }
}

@media screen and (max-width: 400px) {
  .header-name {
    top: 7px;
  }

  .shop_name {
    font-size: 9px;
  }
}
.inactive {
  color: gray !important;
}
</style>
